require("./accountsView.scss");

// @ vendors
const React = require("react");
const { connect } = require("react-redux");
const classNames = require("classnames");
const PropTypes = require("prop-types");
import { withRouter } from "react-router-dom";

// @ actions
const landingActions = require("actions/landings");
const { getChildList } = require("actions/openYoungDashboard");
const hiringProductBannersActions = require("actions/hiringProductBanners");
const offersActions = require("actions/offersActions");

// @ core
import { offersAccountsAdapter } from 'components/offers/adapters/accountsAdapter';
import { i18n } from 'core/i18n';
import { getCurrentAccounts } from "utilities/currentAccountsHelper";
const { formatText, FormattedText, getLanguage } = i18n;
// @ commons
const { OKCover } = require("commonsComponents/OKCover");
const { OKIconTask } = require("commonsComponents/OKIconTask");
const { PopoverMenu } = require("commonsComponents/popoverMenu");
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");

// @ components
const { AccountsBox } = require("components/accounts/accountsBox/accountsBox");
const { CallMeBack } = require("components/callMeBack/callMeBack");
const {
    CommercialAdsCCValidated: CommercialAds,
} = require("components/commons/commercialAds/commercialAds");
const { OKButton } = require("components/commons/OKButton/OKButton");
const AccountsBalance = require("components/accounts/accountsBalance/accountsBalance");
const AccountsProductBanners = require("components/accounts/accountsProductBanners/accountsProductBanners");
const AccountsProductCMSBanners = require("components/accounts/accountsProductCMSBanners/accountsProductCMSBanners");
const AccountsProductDropdown = require("components/accounts/accountsProductBanners/accountsProductDropdown");
const AccountBlockedErrorModal = require("components/accounts/accountBlockedErrorModal/accountBlockedErrorModal");
const ContactCenterRender = require("components/conditionalRender/contactCenterRender");
const OKHeaderLanding = require("components/commons/OKHeaderLanding/OKHeaderLanding");
const OpenYoungDashboardInfo = require("components/openYoungDashboard/openYoungDashboardInfo/openYoungDashboardInfo");
const TutorialLauncher = require("components/tutorial/tutorialLauncher");
const WebappRender = require("components/conditionalRender/webappRender");

// @ helpers
const {
    existCancelledAccounts,
} = require("utilities/contactCenter/cancelledAccountsHelper");
const {
    conditionalClassName,
    contactCenterClassName,
} = require("utilities/conditionals/conditionalClassname");
const { DIRECT_DEBITS } = require("constants/flagBasedFeatures");

// @ constants
const {
    DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT,
    GC,
    NOT_ALLOWED_OY_DASHBOARD_COUNTRIES,
    WEB_OY_DASHBOARD_ENABLED,
} = require("constants/flagBasedFeatures");
const { GRAPHIC_TUTOR_TYPE_2 } = require("constants/index");

class AccountsView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.handleAccountBoxClick = this.handleAccountBoxClick.bind(this);
        this.handleGoToCancelledAccounts = this.handleGoToCancelledAccounts.bind(this);
    }

    componentDidMount() {
        const { immFeatureToggling, validateBlockedAccount, fetchOffers } = this.props;
        immFeatureToggling.get(DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT) &&
            validateBlockedAccount();

        fetchOffers({
            flow: 'ACCOUNTS_LANDING',
            metadata: {
                language: getLanguage().toUpperCase()
            }
        });
    }

    componentWillUnmount() {
        this.props.resetOffers();
    }

    buildAccounts() {
        const {
            immAccounts,
            immAccountsTransactions,
            immLandingBoxes,
            immProfile,
        } = this.props;
        const immAccountsByOrder = immAccounts.get("byOrder");
        const immAccountsById = immAccounts.get("byId");

        if (immAccounts.get("isOutdated")) return;

        const immAllAccountBoxes = immAccountsByOrder.map(
            (accountId, index) => {
                const expanded = immLandingBoxes.includes(index);
                return (
                    <AccountsBox
                        expanded={expanded}
                        immAccount={immAccountsById.get(accountId)}
                        immAccountsTransactions={immAccountsTransactions}
                        immProfile={immProfile}
                        index={index}
                        key={index}
                        onClick={this.handleAccountBoxClick}
                    />
                );
            }
        );

        return <div>{immAllAccountBoxes}</div>;
    }

    buildAccountsCC() {
        const { immAccounts, immAccountsTransactions, immProfile } = this.props;
        const immAccountsByOrder = immAccounts.get("byOrder");
        const immAccountsById = immAccounts.get("byId");

        if (immAccounts.get("isOutdated")) {
            return { all: null, left: null, right: null };
        }

        // It orders the list leaving canceled accounts at the end
        let immAccountsList;
        immAccountsList = immAccountsByOrder.filter((accountId) => {
            if (this.isCancelledView()) {
                return immAccountsById
                    .get(accountId)
                    .getIn(["filters", "canceled"]);
            } else {
                return !immAccountsById
                    .get(accountId)
                    .getIn(["filters", "canceled"]);
            }
        });

        const immAllAccountBoxes = immAccountsList.map((accountId, index) => {
            return (
                <AccountsBox
                    expanded={false}
                    immAccount={immAccountsById.get(accountId)}
                    immAccountsTransactions={immAccountsTransactions}
                    immProfile={immProfile}
                    index={index}
                    key={index}
                    onClick={this.handleAccountBoxClick}
                />
            );
        });

        const immAccountBoxesLeft = immAllAccountBoxes.filter(
            (value, index) => !(index % 2)
        );
        const immAccountBoxesRight = immAllAccountBoxes.filter(
            (value, index) => index % 2
        );

        const all = (
            <section className="accounts-view__accounts">
                {immAllAccountBoxes}
            </section>
        );

        const left = (
            <section className="accounts-view__accounts-left">
                {immAccountBoxesLeft}
            </section>
        );

        const right = (
            <section className="accounts-view__accounts-right">
                {immAccountBoxesRight}
            </section>
        );

        return { all, left, right };
    }

    handleAccountBoxClick(isExpanded, index) {
        this.props.boxToggle(isExpanded, index, "accounts");
    }

    getLinkAccountDebits() {
        const { immAccounts } = this.props;
        const firstAccountId = getCurrentAccounts(
            immAccounts.get("byOrder").toJS(),
            immAccounts.get("byId")
        )[0];
        return `/myprofile/accounts/${firstAccountId}/debits`;
    }

    handleGoToCancelledAccounts() {
        this.props.history.push("/myprofile/accounts/cancelled");
    }

    isCancelledView() {
        return window.location.pathname.includes("cancelled");
    }

    closeModal() {
        this.props.showAccountBlockedErrorModal(false);
    }

    render() {
        const {
            immOffers,
            fetchOffers,
            flagBasedFeatures,
            gestorCrossEnabled,
            getChildList,
            history,
            immAccounts,
            immFeatureToggling,
            immHiringProductBanners,
            immOpenYoungDashboard,
            immProfile,
            showAccountBlockedErrorModal,
            isBalanceDrawn
        } = this.props;
        const immBalances = isBalanceDrawn ? immAccounts.get("balanceDrawn") : immAccounts.get("balance");
        const offers = offersAccountsAdapter(immOffers.toJS(), fetchOffers);
        const title = formatText("landingHeader-accounts");

        const cancelledAccountsButton = __CONTACT_CENTER__ &&
            !this.isCancelledView() && (
                <OKButton
                    modifier={"primary"}
                    onClick={this.handleGoToCancelledAccounts}
                    disabled={!existCancelledAccounts(immAccounts)}
                >
                    <FormattedText value="accounts-seeCancelledAccounts" />
                </OKButton>
            );

        let accountDebitButton;
        if (immAccounts.get("byOrder").size > 0) {
            const targetContentMobile = (
                <PopoverMenu
                    target={
                        <OKIconTask
                            activeHover={false}
                            icon="icon-s-op-comp"
                            type="standalone"
                            style="dark-bg"
                        />
                    }
                    items={[
                        {
                            link: this.getLinkAccountDebits(),
                            text: formatText("accounts-debits"),
                        },
                    ]}
                    placement="bottomRight"
                />
            );
            const buttonClassName = conditionalClassName("ghost", "primary");
            accountDebitButton = !__CONTACT_CENTER__ ? (
                <div className="accounts-view__account-debit-button">
                    <div className="hidden-xs">
                        <OKButton
                            modifier={buttonClassName}
                            inverse={true}
                            to={this.getLinkAccountDebits()}
                        >
                            <FormattedText value="accounts-debits" />
                        </OKButton>
                    </div>
                    <div className="visible-xs">{targetContentMobile}</div>
                </div>
            ) : (
                <OKButton
                    modifier={buttonClassName}
                    inverse={true}
                    to={this.getLinkAccountDebits()}
                >
                    <FormattedText value="accounts-debits" />
                </OKButton>
            );
        }

        const accounts = __CONTACT_CENTER__
            ? this.buildAccountsCC()
            : this.buildAccounts();
        let accountsProductBanners;
        if (__CONTACT_CENTER__) {
            accountsProductBanners = null;
        } else if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            accountsProductBanners = <AccountsProductCMSBanners limit={10} />;
        } else if (immOffers.get('fetched')) {
            accountsProductBanners = (
                <AccountsProductBanners immAccounts={immAccounts} amount={10} offers={offers} history={history} immOffers={immOffers} />
            );
        } else  {
            accountsProductBanners = null;
        }

        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_2}
                title={formatText("tutorials-accountsTitle")}
            />
        );
        const containerClassName = contactCenterClassName(
            "grid-view accounts-view"
        );
        const gridViewBodyClassName = contactCenterClassName(
            "accounts-view__body",
            "grid-view__body"
        );
        const accountsViewLeftColumnClassName = conditionalClassName(
            "col-xs-12 col-md-8 col-lg-8",
            "accounts-view__left-column col-xs-6"
        );
        const accountsViewRightColumnClassName = conditionalClassName(
            "col-xs-12 col-md-4 col-lg-4",
            "accounts-view__right-column col-xs-6"
        );
        const accountsBalance = contactCenterClassName(
            "accounts-view__balance col-xs-12"
        );

        const breadcrumbCancelledAccounts = [
            {
                text: formatText("breadcrumb-accounts"),
                url: "/myprofile/accounts",
            },
            {
                text: formatText("accounts-subtitleCancelledAccounts"),
                url: "",
            },
        ];

        const OKHeaderView = this.isCancelledView() ? (
            <OKCover size="medium" section="accounts" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumbCancelledAccounts}
                    finalTitle={formatText("landingHeader-accounts")}
                    subtitleLeft={formatText(
                        "accounts-subtitleCancelledAccounts"
                    )}
                    tutorial={tutorial}
                    className="ok-header-landing--cancelled-accounts"
                >
                    <AccountsProductDropdown
                        immAccounts={immAccounts}
                        immProfile={immProfile}
                        amount={10}
                        immFeatureToggling={immFeatureToggling}
                    />
                </OKHeaderSubPage>
                {!__CONTACT_CENTER__ && accountDebitButton}
            </OKCover>
        ) : (
            <OKCover size="small" section="accounts" customClass="col-xs-12">
                <OKHeaderLanding
                    title={title}
                    tutorial={tutorial}
                    inputClassName="ok-header-landing--accounts"
                >
                    {cancelledAccountsButton}
                    <ContactCenterRender>
                        <AccountsProductDropdown
                            immAccounts={immAccounts}
                            immProfile={immProfile}
                            amount={10}
                            immFeatureToggling={immFeatureToggling}
                            immHiringProductBanners={immHiringProductBanners}
                            showAccountBlockedErrorModal={
                                showAccountBlockedErrorModal
                            }
                            offers={offers}
                        />
                    </ContactCenterRender>
                    {flagBasedFeatures.get(DIRECT_DEBITS) && accountDebitButton}
                </OKHeaderLanding>
            </OKCover>
        );

        const bodyClassNames = classNames("container-fluid", {
            "grid-view--content-position-positive":
                !__CONTACT_CENTER__ ||
                (__CONTACT_CENTER__ && !this.isCancelledView()),
            "grid-view--content-position-negative":
                __CONTACT_CENTER__ && this.isCancelledView(),
        });

        let oyDashboardInfoSection;
        if (
            flagBasedFeatures.get(WEB_OY_DASHBOARD_ENABLED) &&
            flagBasedFeatures.get(NOT_ALLOWED_OY_DASHBOARD_COUNTRIES)
        ) {
            oyDashboardInfoSection = (
                <OpenYoungDashboardInfo
                    getChildList={getChildList}
                    immOpenYoungDashboard={immOpenYoungDashboard}
                />
            );
        }

        let accountBlockedErrorModal;
        if (__CONTACT_CENTER__) {
            const showErrorModal =
                immHiringProductBanners.get("showErrorModal");
            accountBlockedErrorModal = (
                <AccountBlockedErrorModal
                    description={
                        <FormattedText value="accountBlockedErrorModal-errorDescriptionCC" />
                    }
                    handleSubmit={this.closeModal}
                    showModal={showErrorModal}
                    title={formatText("accountBlockedErrorModal-errorTitleCC")}
                />
            );
        }

        return (
            <div className={containerClassName}>
                <div className="container-fluid">
                    <div className="row">{OKHeaderView}</div>
                </div>
                <div className={gridViewBodyClassName}>
                    <div className={bodyClassNames}>
                        {!this.isCancelledView() && (
                            <ContactCenterRender>
                                <div className="row">
                                    <div className={accountsBalance}>
                                        <AccountsBalance
                                            immBalances={immBalances}
                                        />
                                        {accountBlockedErrorModal}
                                    </div>
                                </div>
                            </ContactCenterRender>
                        )}
                        <div className="row">
                            <div className={accountsViewLeftColumnClassName}>
                                <div className="row">
                                    <WebappRender>
                                        <div className="col-xs-12 hidden-md hidden-lg grid-view--fix-cell-separation-bottom">
                                            <AccountsBalance
                                                immBalances={immBalances}
                                            />
                                        </div>
                                        <div className="col-xs-12">
                                            {accounts}
                                        </div>
                                        <div className="hidden-xs hidden-sm col-md-12">
                                            {accountsProductBanners}
                                        </div>
                                    </WebappRender>
                                    <ContactCenterRender>
                                        {accounts.left}
                                    </ContactCenterRender>
                                </div>
                            </div>
                            <div className={accountsViewRightColumnClassName}>
                                <div className="row">
                                    <WebappRender>
                                        <div className="hidden-xs hidden-sm col-md-12 grid-view--variable-cell-separation">
                                            <AccountsBalance
                                                immBalances={immBalances}
                                            />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            {oyDashboardInfoSection}
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <CommercialAds
                                                path="accounts"
                                                type="banner-b"
                                            />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <CallMeBack
                                                isSmall={true}
                                                hasEntrance={false}
                                                pageTitle={formatText(
                                                    "landingHeader-accounts"
                                                )}
                                            />
                                        </div>
                                    </WebappRender>
                                    <ContactCenterRender>
                                        {accounts.right}
                                    </ContactCenterRender>
                                </div>
                            </div>
                            <WebappRender>
                                <div className="col-xs-12 hidden-md hidden-lg">
                                    {accountsProductBanners}
                                </div>
                            </WebappRender>
                        </div>
                    </div>
                </div>
                <div className="container-fluid grid-view__cross-selling">
                    <div className="row">
                        <CommercialAds path="accounts" type="cross-selling" />
                    </div>
                </div>
            </div>
        );
    }
}

AccountsView.propTypes = {
    boxToggle: PropTypes.func,
    children: PropTypes.any,
    fetchOffers: PropTypes.func.isRequired,
    resetOffers: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    getChildList: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountsTransactions: PropTypes.object.isRequired,
    immFeatureToggling: PropTypes.shape({}),
    immHiringProductBanners: PropTypes.object,
    immLandingBoxes: PropTypes.object,
    immOffers: PropTypes.object.isRequired,
    immOpenYoungDashboard: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    showAccountBlockedErrorModal: PropTypes.func,
    validateBlockedAccount: PropTypes.func,
    isBalanceDrawn: PropTypes.func
};

module.exports.constructor = AccountsView;
module.exports.AccountsView = connect(
    (state) => ({
        flagBasedFeatures: state.flagBasedFeatures,
        gestorCrossEnabled: state.flagBasedFeatures.get("web-gc-enabled"),
        immAccounts: state.accounts,
        immAccountsTransactions: state.accountsTransactions,
        immFeatureToggling: state.flagBasedFeatures,
        immHiringProductBanners: state.hiringProductBanners,
        immLandingBoxes: state.landings.get("expandedBoxes").get("accounts"),
        immOffers: state.offers,
        immOpenYoungDashboard: state.openYoungDashboard,
        immProfile: state.profile,
    }),
    {
        boxToggle: landingActions.boxToggle,
        getChildList,
        showAccountBlockedErrorModal:
            hiringProductBannersActions.showAccountBlockedErrorModal,
        validateBlockedAccount:
            hiringProductBannersActions.validateBlockedAccount,
        fetchOffers: offersActions.fetchOffers2,
        resetOffers: offersActions.reset,
    }
)(withRouter(AccountsView));
